import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { MatDialog } from "@angular/material";

import { RestApiService } from "../shared/restApiServices/restapi.service";
import {BroadcastEventService} from "../shared/services/broadcast.event.service";
import { LogInDialogComponent } from "../logInComponent/log-in.component";
import {ShowToastyService } from "../shared/services/showToastyService";
import { DialogBoxComponent } from 'app/dialog-box/dialog-box.component';

@Component({
  selector: 'app-fill-form',
  templateUrl: './fill-form.component.html',
  styleUrls: ['./fill-form.component.css']
})
export class FillFormComponent implements OnInit {
    quserID:string;
    showQuestionnaire : boolean = false;
    finalDataToSave:any = {};
    cascadQuestion:any;
    questions;
    mobileScreen : boolean;
    companyLogo: string;

  constructor(private restApiService:RestApiService,private dialog:MatDialog, private route:ActivatedRoute, private broadcastEventService:BroadcastEventService, private showToastyService:ShowToastyService, private cdr:ChangeDetectorRef) {
    this.route.params.subscribe(params => {
      this.quserID = params['id'];
      this.getQuestions();
    });
    this.getLocationData();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    let windowWidth = window.innerWidth;
    if (windowWidth < 768) {
      this.mobileScreen = true;
    }
    else {
      this.mobileScreen = false;
    }
    this.cdr.detectChanges();
  }

  showDefaultlogo(){
    this.companyLogo = "../../assets/images/whiteLogo.png";
  }

  getQuestions(){
    this.restApiService.getFormInfoAndQuestions(this.quserID).subscribe(
      questions => {
        // console.log(questions);
        if(questions.success == false)
        {
          this.openLoginDialog();
        }
        else{
          this.showQuestionnaire = true;
          let versionsQuestionnaire = questions.result[0]['quesVersions'];
          this.companyLogo =  'https://s3.ap-south-1.amazonaws.com/survey-manager/userProfiles/' + questions.result[0]['adminID'] ;
          if (Boolean(versionsQuestionnaire)) {
            this.questions = versionsQuestionnaire[versionsQuestionnaire.length - 1];
          }
          else {
            this.questions = questions.result[0].question;
          }
          localStorage.setItem("test123",JSON.stringify(this.questions));
          let res = JSON.parse(localStorage.getItem("surveyorToken"));
          this.cascadQuestion = questions.result[0]['cascadeLocation'];
          this.finalDataToSave['sub'] =  Boolean(res) && Boolean(res['loginId'])? res['loginId'] : "";
          this.finalDataToSave['surveyID'] = this.quserID;
          this.finalDataToSave['adminID'] = questions.result[0]['adminID'];
          this.finalDataToSave['superAdminID'] = questions.result[0]['adminID'];
          this.finalDataToSave['survey'] = {
            "surveyType": this.quserID,
            "formType": null,
            "fnT": null,
            "inT": null,
            "question": [],
            "groupID": null,
            "surveyVal" : 'Sy',
            "totalMandatoryQuestions": questions.result[0]['num_qns'],
            "totalAnsweredQuestions" : questions.result[0]['num_qns'],
            "questionaireID": this.quserID
          };
          let versionsOfSurvey = questions.result[0]['versions'];
          this.finalDataToSave['survey']['version'] = Boolean(versionsOfSurvey)?versionsOfSurvey[versionsOfSurvey.length -1]: 'v0';
          this.broadcastEventService.setQuestions(this.questions);
        }
      });
  }

  openLoginDialog(){
    let dialog = this.dialog.open(LogInDialogComponent,{
      width: '45rem',
      disableClose : true
    })
    dialog.afterClosed().subscribe(res=>{
      if(res.success == true)
      {
        this.getQuestions();
      }
    })
  }

  getLocationData() {
    navigator.geolocation.getCurrentPosition((location) => {
      this.finalDataToSave['lat']  = (location.coords.latitude);
      this.finalDataToSave['lng'] = (location.coords.longitude);
    },
    error => {
      this.finalDataToSave['lat']  = '';
      this.finalDataToSave['lng'] = '';
      // console.log(error.code);
    },
    { timeout: 5000, enableHighAccuracy: true})
}

  onSave()
  {
    let formQuestions = JSON.parse(localStorage.getItem("test123"));
    let arr = []
    // console.log(formQuestions);
    let dependentQuestion = null;
    for(let data in formQuestions)
    {
      if(formQuestions[data]['Is_Mandt']) {
        for(var i = 0; i < formQuestions[data]['user_Res'].length; i++) {
          if(formQuestions[data]['Opt_Dep'].length > 0){
            dependentQuestion = formQuestions[data]['Qn_Num'];
          }
          if(formQuestions[data]['user_Res'][i] === "" && formQuestions[data]['Qn_Type'] != 'Break') {
            if(dependentQuestion == null){
              arr.push(formQuestions[data]['Qn_In']);
            }
            else{
              if(formQuestions[Number(data) - 1]['Qn_Deps'].indexOf(dependentQuestion) > -1 && formQuestions[Number(data) - 1]['user_Res'][i] !== "" &&  formQuestions[Number(data) - 1]['user_Res'][i] == formQuestions[data]['Opt_Dep'][0]){
                arr.push(formQuestions[data]['Qn_In']);
              }
              if(formQuestions[Number(data) - 1]['Qn_Deps'].indexOf(dependentQuestion) == -1){
                arr.push(formQuestions[data]['Qn_In']);
              }
            }
            break;
          }
        }
      }
    }
    if(arr.length != 0)
    {
      var str = ""
      for(var i = 0; i < arr.length; i++)
      {
        if(i == arr.length - 1)
        {
          str = str + arr[i];
        }
        else
        {
          str = str + arr[i] + ",";
        }
      }
      this.showToastyService.failure("Fill the following questions", str);
    }
    else
    {
      let resposesStorage = [] ;
      for(let data in formQuestions)
      {
        // console.log(formQuestions[data]['Qn_In'] + "    " + formQuestions[data]['Qn_Num'] )
        // console.log(formQuestions[data]['user_Res']);
        if (formQuestions[data]['is_Visible']) {
          if (formQuestions[data]['user_Res'][0] != '') {
            if (formQuestions[data]['Qn_Type'] == "Radio") {
              let answerValue = formQuestions[data]['Opt_Name'][formQuestions[data]['user_Res'][0]];
              resposesStorage.push(answerValue);
            }
            else if (formQuestions[data]['Qn_Type'] == "Checkbox") {
              let selectedOptions = formQuestions[data]['user_Res'][0].split(" ");
              // responseArray array is of length of the options available with a default value of false for its elements
              let responseArray = Array.apply(null, new Array(formQuestions[data]['Opt_Name'].length)).map(Boolean.prototype.valueOf, false);
              responseArray.fill(false);
              for (let answer of selectedOptions) {
                if (!isNaN(parseInt(answer))) {
                  responseArray[answer] = true;
                }
              }
              resposesStorage.push(responseArray);
            }
            else {
              resposesStorage.push(formQuestions[data]['user_Res'][0]);
            }
          }
          else {
            resposesStorage.push("-1");
          }
        }
        else if (!formQuestions[data]['is_Visible']) {
          if (formQuestions[data]['Qn_Type'] == "Radio") {
            let responseArray = [];
            for (let dataValue in formQuestions[data]['user_Res']) {
              responseArray.push(formQuestions[data]['Opt_Name'][formQuestions[data]['user_Res'][dataValue]])
            }
            resposesStorage.push(responseArray);
          }
          else if (formQuestions[data]['Qn_Type'] == "Checkbox") {
            let CheckboxResponsesArray = [];
            for (let dataValue in formQuestions[data]['user_Res']) {
              let selectedOptions = formQuestions[data]['user_Res'][dataValue].split(" ");
              // responseArray array is of length of the options available with a default value of false for its elements
              let responseArray = Array.apply(null, new Array(formQuestions[data]['Opt_Name'].length)).map(Boolean.prototype.valueOf, false);
              responseArray.fill(false);
              for (let answer of selectedOptions) {
                if (!isNaN(parseInt(answer))) {
                  responseArray[answer] = true;
                }
              }
              CheckboxResponsesArray.push(responseArray);
            }
            resposesStorage.push(CheckboxResponsesArray);
          }
          else {
            resposesStorage.push(formQuestions[data]['user_Res']);
          }
        }

      }

      this.finalDataToSave['survey']['question'] = resposesStorage;
      this.finalDataToSave['survey']['updatedTime'] = (new Date()).toUTCString() ;
      this.finalDataToSave['survey']['syncTime'] = (new Date()).toUTCString() ;
      this.finalDataToSave['survey']['longitude'] = this.finalDataToSave['lng'];
      this.finalDataToSave['survey']['latitude'] = this.finalDataToSave['lat'] ;
      this.finalDataToSave['survey']['surveyTime'] = new Date().getTime();
      this.finalDataToSave['survey']['surveyName'] =  (new Date().getTime()).toString();

      this.restApiService.syncQnrData(this.finalDataToSave).subscribe(res =>{
      if(res.success == true)
      {
        // this.showToastyService.success('Successfully Synced','Your response was saved');
        this.openSuccessfulSubmissionDialog();
      }
      else{
        console.log(res);
        this.showToastyService.failure('Error while saving','');
      }
    });
    }
  }

  openSuccessfulSubmissionDialog() {
    let dialogRef
    if (this.mobileScreen) {
      dialogRef = this.dialog.open(DialogBoxComponent, {
        width: '90vw',
        maxWidth:'90vw',
        data: {}
      })
    }
    else {
      dialogRef = this.dialog.open(DialogBoxComponent, {
        width: '50vw',
        data: {}
      })
    }
    dialogRef.afterClosed().subscribe(res => {
      // console.log(res);
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/fill-form/fill-form.component.ts